import gql from 'graphql-tag';

export const LISTING_ADDITIONAL_LINKS_FRAGMENT = gql`
    fragment LISTING_ADDITIONAL_LINKS_FRAGMENT on ListingData {
        additionalLinks {
            ... on Media {
                caption
                original
                type
            }
        }
    }
`;
